if (!customElements.get('video-lazyload')) {
    customElements.define(
        'video-lazyload',
        class VideoLazyLoad extends HTMLElement {
        constructor() {
            super();

            this.video = this.querySelector('video');

            this.initLoadEvent();
        }

        initLoadEvent() {
            const video = this.querySelector(`video`);

            const observer = new IntersectionObserver(
        (entries) => {
                    entries.forEach(({ isIntersecting }) => {
                        if (isIntersecting) {
                            video.play();

                            observer.unobserve(video);
                        }
                    });
                }
            );

            observer.observe(video);
        }
    });
}
